/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function PartnerPlannerEditorController(
    _,
    $routeParams,
    $timeout,
    BreadcrumbService,
    PartnerEditService,
    UtilsService
) {

    var self = this;
    var requiredFields = ['name', 'lookBack', 'lookForward', 'filenameExpression'];

    self.updateRequiredFields = function () {
        var oldField = self.plannerObject.scheduleType === 'weekly' ? 'frequency' : 'scheduleTimeOfDay';
        var newField = self.plannerObject.scheduleType === 'recurring' ? 'frequency' : 'scheduleTimeOfDay';

        var oldIndex = requiredFields.indexOf(oldField);
        if (oldIndex > -1) {
            requiredFields.splice(oldIndex, 1);
        }
        requiredFields.push(newField);
    };

    var getPlannerEditData = function () {
        self.loadingIndicator.show = true;
        PartnerEditService.getPlannerEditViewData().then(function (data) {
            self.availableDeliveryEndpoints = data.availableDeliveryEndpoints;
            self.availableEmailEndpoints = data.availableEmailEndpoints;
            self.availableTransformTemplates = data.availableTransformTemplates;
            self.partnerObject = data.partnerObject;
            self.plannerObject = data.plannerObject;

            if (!!self.partnerObject.name) {
                self.breadcrumbName = self.plannerObject.name;
            }

            self.partnerBreadcrumb.location = '/system/partners/edit/' + self.partnerObject.id + '/planner';
            self.partnerBreadcrumb.name = self.partnerObject.name;

            self.updateRequiredFields();

            self.loadingIndicator.show = false;
        });
    };

    self.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    self.$onInit = function () {
        // This is two-screens deep from the partners list - add a
        // breadcrumb back to the partner
        self.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null
        };
        BreadcrumbService.addBreadcrumb(self.partnerBreadcrumb);
        // This planner's breadcrumb
        self.breadcrumbName = 'New Planner';

        BreadcrumbService.editService = PartnerEditService;
        self.editService = PartnerEditService;

        getPlannerEditData();
    };

    self.$postLink = function () {
        $timeout(function () {
            PartnerEditService.editorForm = self.editorForm;
        });
    };

    PartnerEditService.saveDisabled = function () {
        if (self.plannerObject && !self.plannerObject.deliveryEndpoint && !self.plannerObject.emailEndpoint) {
            return true;
        }
        return requiredFields.reduce(function (accum, field) {
            return accum || self.plannerObject && !(UtilsService.hasData(self.plannerObject[field]));
        }, false);
    };

    self.deliveryEndpointChange = function () {
        delete self.plannerObject.passwordExpression;
        delete self.plannerObject.targetPathExpression;
        delete self.plannerObject.userNameExpression;
    };

    self.onSave = function () {
        self.loadingIndicator.show = true;
        PartnerEditService
            .savePartnerPlanner(self.plannerObject)
            .then(function () {
                self.breadcrumbName = self.plannerObject.name;
                self.plannerObject = PartnerEditService.plannerObject;
                self.loadingIndicator.show = false;
            });
    };

    self.onRevert = function () {
        PartnerEditService.revertPartnerPlanner();
        self.plannerObject = PartnerEditService.plannerObject;
    };

    self.onClose = function () {
        PartnerEditService.closePlannerEditView();
    };

    self.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: function() {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                var saveDisabled = PartnerEditService.saveDisabled && PartnerEditService.saveDisabled() === true;
                return !isProcessing && (isNew || !isPristine) && !saveDisabled;
            },
            onClick: self.onSave
        },
        {
            label: 'Revert',
            enabled: function() {
                var isProcessing = self.loadingIndicator.show;
                var isNew = $routeParams.id <= -1;
                var isPristine = PartnerEditService.editorForm && PartnerEditService.editorForm.$pristine;
                return !isProcessing && (isNew || !isPristine);
            },
            onClick: self.onRevert
        },
        {
            label: 'Close',
            enabled: function() { return !self.loadingIndicator.show; },
            onClick: self.onClose
        }
    ];

    self.onStepperChanged = function (object, prop, min, max) {
        var value = object[prop];
        if (!value) {
            object[prop] = min;
        } else if (!_.isNil(max) && value > max) {
            object[prop] = max;
        } else if (!_.isNil(min) && value < min) {
            object[prop] = min;
        }
    };
}

angular.module('prism-ui.partner').component('partnerPlannerEditor', {
    templateUrl: 'system/partner/editor/components/view/planner/editor/partner-planner-editor-template.html',
    controller: PartnerPlannerEditorController,
    bindings: {},
});
